import React from "react";

const MockFormModal = ({ title, onClose, children }) => (
    <div className="clk-mk-modal-backdrop" onClick={onClose} role="presentation">
        <div
            className="clk-mk-modal clk-mk-form-modal"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="clk-mk-form-modal-title"
        >
            <div className="clk-mk-form-modal-head">
                <h5 id="clk-mk-form-modal-title">{title}</h5>
                <button type="button" className="clk-mk-modal-close" onClick={onClose} aria-label="Close">
                    ×
                </button>
            </div>
            {children}
        </div>
    </div>
);

export default MockFormModal;
